import map from 'lodash/map';

import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import generateId from 'src/lib/generateId';
import useResource, { STATUS_FAILED } from 'src/presentation/hooks/useResource';
import webhooksResource from 'src/actions/integrations/webhooksResource';
import { Webhook } from 'src/actions/integrations/webhook';
import { toastError } from 'src/actions/toast';

const useWebhooks = () => {
  const dispatch = useDispatch();
  const { values: webhooks, loadingState, errors } = useResource<Webhook>(webhooksResource);

  const toggleStatus = async (item: Webhook) => {
    const customToastMsg = `Webhook '${item.name}' ${item.enabled ? 'disabled' : 'enabled'}`;
    const itemToUpdate = {
      enabled: !item.enabled,
    };

    await dispatch(
      webhooksResource.effects.update({ id: item.id }, itemToUpdate, {
        customToastMsg,
        disableWindowBack: true,
        patch: true,
      })
    );

    dispatch(webhooksResource.actions.resetErrors({}));
  };

  useEffect(() => {
    if (loadingState === STATUS_FAILED) {
      dispatch(toastError('Error while loading data. Please wait and try refreshing the page'));
    }
  }, [loadingState, dispatch]);

  return { webhooks, loadingState, errors, toggleStatus };
};

export function convertHeaderKeysToHeadersArray(headerKeys: string[] = []) {
  return map(headerKeys, key => ({ id: generateId(), name: key }));
}

export default useWebhooks;
